import React from 'react';

import { bemComponent } from '@99designs/common/utils/app';

interface ContentBodyContainerProps {
    variations?: string[];
    children: React.ReactNode;
}

const ContentBody = bemComponent('content-body', 'ContentBody');
const ContentBodyInner1 = bemComponent('content-body__inner-1', 'ContentBodyInner1');
const ContentBodyInner2 = bemComponent('content-body__inner-2', 'ContentBodyInner1');

export default function ContentBodyContainer({
    children,
    variations = [],
}: ContentBodyContainerProps) {
    return (
        <ContentBody variations={variations} data-testid="ContentBody">
            <ContentBodyInner1>
                <ContentBodyInner2>{children}</ContentBodyInner2>
            </ContentBodyInner1>
        </ContentBody>
    );
}
